import Dbm from "dbm";
import Website from "../../index.js";

export default class AssetObject extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("loaded", false);
        this.item.setValue("status", Dbm.loading.LoadingStatus.NOT_STARTED);

        let allLoaded = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);
        this.item.setValue("allLoaded", allLoaded);
        
        this.item.properties.loaded.connectInput(allLoaded.output.properties.value);

        this.item.setValue("animations", {});
    }

    addAnimation(aName, aStartIndex, aEndIndex, aFilePrefix = null, aFileSuffix = ".png") {
        if(!aFilePrefix) {
            aFilePrefix = aName + "-";
        }
        
        let assetAnimation = new Website.game.assets.AssetAnimation();
        assetAnimation.item.register(this.item.id + "/" + aName);
        this.item.animations[aName] = assetAnimation;
        
        let fullFilePathPrefix = this.item.assetsFolder + "/" + aFilePrefix;
        assetAnimation.setup(fullFilePathPrefix, aStartIndex, aEndIndex, aFileSuffix);

        this.item.allLoaded.addCheck(assetAnimation.item.properties.status);

        return assetAnimation;
    }

    addSingleImage(aName, aFileName = null, aFileSuffix = ".png") {

        if(!aFileName) {
            aFileName = aName;
        }

        let assetAnimation = new Website.game.assets.AssetAnimation();
        assetAnimation.item.register(this.item.id + "/" + aName);
        this.item.animations[aName] = assetAnimation;

        let fullFilePath = this.item.assetsFolder + "/" + aFileName + aFileSuffix;
        assetAnimation.setSingleImage(fullFilePath);

        this.item.allLoaded.addCheck(assetAnimation.item.properties.status);

        return assetAnimation;
    }

    addRootImage(aName = "main", aFileSuffix = ".png") {
        let assetAnimation = new Website.game.assets.AssetAnimation();
        assetAnimation.item.register(this.item.id + "/" + aName);
        this.item.animations[aName] = assetAnimation;

        let fullFilePath = this.item.assetsFolder + aFileSuffix;
        assetAnimation.setSingleImage(fullFilePath);

        this.item.allLoaded.addCheck(assetAnimation.item.properties.status);

        return assetAnimation;
    }

    addSoundFile(aName, aFileName = null, aFileSuffix = ".mp3") {
        if(!aFileName) {
            aFileName = aName;
        }

        let assetAnimation = new Website.game.assets.AssetAnimation();
        assetAnimation.item.register(this.item.id + "/" + aName);
        this.item.animations[aName] = assetAnimation;

        let fullFilePath = this.item.assetsFolder + "/" + aFileName + aFileSuffix;
        assetAnimation.setSingleSound(fullFilePath);
        assetAnimation.item.scaleMode = null;

        this.item.allLoaded.addCheck(assetAnimation.item.properties.status);

        return assetAnimation;
    }

    load() {
        if(this.item.status !== Dbm.loading.LoadingStatus.NOT_STARTED) {
            return this;
        }

        this.item.status = Dbm.loading.LoadingStatus.LOADING;
        Dbm.flow.runWhenMatched(this.item.properties.loaded, true, Dbm.commands.setProperty(this.item.properties.status, Dbm.loading.LoadingStatus.LOADED));

        let animations = this.item.animations;
        for(let objectName in animations) {
            animations[objectName].load();
        }
    }
}